<template>
  <div class="tela_de_login">
    <el-row type="flex" justify="center">
      <el-col :span="10">

<el-card class="login-card">
  <el-row type="flex" justify="center">
      <el-col :span="24">
      <el-image
      style="width: 200px;"
      :src="url"
      :fit="fit"></el-image>

      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h3>Acesso Restrito</h3>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
        <el-form
          :model="ruleFormLogin"
          :rules="rules"
          ref="ruleFormLogin"
          :label-position="labelPosition"
          class="demo-ruleForm"
        >
          <el-radio-group v-model="radio" v-on:change="alteraDados">
            <el-radio label="email">E-mail</el-radio>
            <el-radio label="user">Usuário SGE</el-radio>
          </el-radio-group>

          <el-form-item v-show="ver_user" label="Usuário" prop="usuario">
            <el-input v-model="ruleFormLogin.usuario"></el-input>
          </el-form-item>

          <el-form-item v-show="ver_email" label="E-mail" prop="email">
            <el-input v-model="ruleFormLogin.email"></el-input>
          </el-form-item>

          <el-form-item label="Senha" prop="password">
            <el-input placeholder="Informe a senha." v-model="ruleFormLogin.password" show-password></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitFormLogin()">Acessar</el-button>
          </el-form-item>
          <p>Versão 1.0.11</p>
        </el-form>
      </el-col>
    </el-row>
</el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>

export default {
  data() {
    return {
      fit: 'scale-down',
      url: '/static/logo.png',
      labelPosition: "right",
      radio: "email", //padrão mostra email
      ver_email: true,
      ver_user: false,
      ruleFormLogin: {
        email: "",
        usuario: "",
        password: "",
      },
      rules: {
        email: [
          {  message: "Informe o e-mail.", trigger: "blur" },
          {
            type: "email",
            message: "Informe um e-mail válido.",
            trigger: ["blur", "change"],
          },
        ],
        usuario: [
          {  message: "Informe o usuário.", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
  },
  methods: {
    submitFormLogin() {
      // console.log("submitFormLogin")
      let tipo = 'email';
      let email_user = '';
      let valida = false;
      if (this.ver_email == true) {
          tipo = 'email';
          email_user=this.ruleFormLogin.email;
          if (email_user.length > 3) {
              valida=true;
          }
      } else { //usuario
          tipo = 'user';
          email_user=this.ruleFormLogin.usuario;
          if (email_user.length > 3) {
              valida = true;
          }
      } 

      // console.log("0")

      if (valida) {  

        // console.log("1A")
        const password = this.ruleFormLogin.password;

        // console.log("tipo: ", tipo);
        // console.log("email_user: ", email_user); 
        // console.log("password: ", password);
        this.$store
          .dispatch("login", { email_user, password, tipo })
          .then(() => this.$router.push("/"))
          .catch(() => {
            // console.log('Erro de login:', err.response?.data || err);
            this.$message.error({message: "Dados não conferem. Informe os dados corretamente3!"});
            return false;
          });
      } else {
        this.$message.error({message: "Informe os dados corretamente3!"});
        return false;
      }
        // console.log("2A")
    },
    alteraDados(data) {
      if (data == "email") {
        this.ver_user = false;
        this.ver_email = true;
      } else {
        this.ver_user = true;
        this.ver_email = false;
      }
    },
  },
};
</script>
<style >

  .login-card {
    /* width: 480px; */
    border-radius: 4px;
    margin-left: 100px;
    margin-top:100px;
  }
.el-col {
  border-radius: 4px;
}
/* .bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
} */
</style>
